export const onFocusCollapse = ((vm) => {
    const collapses = vm.$el.querySelectorAll(
        '.collapse:not(.show)'
    )
    if(collapses){
        collapses.forEach(collapse => {
            let campo = collapse.querySelector(
                '[name="' 
                + vm.$validator.errors.items[0].field 
                + '"]:not([disabled])'
            )
            if(campo){
                let idCollapse = collapse.getAttribute('id')
                let selector = vm.$el.querySelector('[aria-controls="' + idCollapse + '"]')
                if(selector){
                    selector.click()
                }
                setTimeout(() => {
                    campo.focus()
                    campo.scrollIntoView(
                        { 
                            behavior: 'smooth', 
                            block: 'center' 
                        }
                    )
                }, 10)
            }
        })
    }
 })

export const onFocusTab = ((vm) => {
   const tabs = vm.$el.querySelectorAll(
       '[role="tabpanel"]'
    )
    if(tabs){
        tabs.forEach(tab => {
            let campo = tab.querySelector(
                '[name="' 
                + vm.$validator.errors.items[0].field 
                + '"]'
            )
            if(campo){
                let idTab = tab.getAttribute('id')
                vm.$el.querySelector(
                    '[aria-controls="' 
                    + idTab + '"]'
                ).click()
                setTimeout(() => {
                    campo.focus()
                    campo.scrollIntoView(
                        { 
                            behavior: 'smooth', 
                            block: 'center' 
                        }
                    )
                }, 10)
            }
        })
    }
})

export const onFocusField = ((vm) => {
     
    let campo = null
    let position = 0

    do {
        campo = vm.$el.querySelector(
            '[name="' 
                + vm.$validator.errors.items[position].field 
            + '"]'
        )

        position++
        
    } while (!campo || vm.$validator.errors.items.length < position)

    if (campo) {
        setTimeout(() => {
            campo.focus()
            campo.scrollIntoView(
                { 
                    behavior: 'smooth', 
                    block: 'center' 
                }
            )
        }, 10)
    }
 })

 export const onFocusTabObserver = ((vm = null) => {
    let campo
    let tabs
    if(vm){
        tabs = vm.$el.querySelectorAll(
            '[role="tabpanel"]'
        )
    }else{
        tabs = document.querySelectorAll(
            '[role="tabpanel"]'
        )
    }
    if(tabs){
        tabs.forEach(tab => {
            campo = tab.querySelector('.error')
            if(campo){
                let idTab = tab.getAttribute('id')
                document.querySelector(
                    '[aria-controls="' 
                    + idTab + '"]'
                ).click()
            }
        })
    }
    campo = document.querySelector('.error')
    if(campo){
        setTimeout(() => {
            campo.focus()
            campo.scrollIntoView(
                { 
                    behavior: 'smooth', 
                    block: 'center' 
                }
            )
        }, 10)
    }
})

export const disableFields = ((el) => {
    setTimeout(() => {
        const inputs = el.querySelectorAll('input')
        const selects = el.querySelectorAll('select')
        const fields = [...inputs, ...selects]
        if(fields.length){
            fields.forEach(field => {
                field.disabled = true
            })
        }
        const suggests = el.querySelectorAll('.selected')
        if(suggests.length){
            suggests.forEach(suggest => {
                suggest.classList.add('disabled')
            })
        }
    }, 100)
})
